import ElementCornerSquares from './ElementCornerSquares';
import type { ElementCornerSquaresProps } from './types';

export type { ElementCornerSquaresProps };
export default ElementCornerSquares;
